import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;

  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.cinza50};
`;

export const Tab = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  cursor: pointer;

  padding: 15px;

  position: relative;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.white};

    font-weight: ${({ active }) => (active ? "bold" : "normal")};
  }
`;

export const Indicator = styled.div`
  width: 100%;
  height: 4px;

  display: ${({ active }) => (active ? "block" : "none")};

  background-color: ${({ theme, active }) =>
    active ? theme.colors.primary.orange : theme.colors.neutral.cinza50};

  position: absolute;
  bottom: -3px;
  left: 0;
`;
